import { actionTypes } from '../_action/result.action';
import { ResultState, ActionDataType } from './types';
import { amenities } from '../../constants/Amenities';

const initialState: ResultState = {
  propertyCount: 0,
  propertyLocation: '',
  propertyDaterange: '',
  totalGuest: 0,
  adultsCount: 0,
  childrenCount: 0,
  babiesCount: 0,
  petsCount: 0,
  bedCount: 0,
  bathroomCount: 0,
  bedroomCount: 0,
  price: [59, 799],
  sortBy: 'aToZ',
  travelingWork: false,
  travelingChild: false,
  amenities: [],
  amenitiesData: amenities.map(amenitiy => ({ ...amenitiy, status: false })),
  paginationLimit: 6,
  paginationOffset: 0,
  view: 'grid'
};

let adultsCount = 0;
let childrenCount = 0;
let babiesCount = 0;
let petsCount = 0;
let bedCount = 0;
let bathroomCount = 0;
let bedroomCount = 0;

let travelingWork = false;
let travelingChild = false;

const result = (state = initialState, action: ActionDataType) => {
  switch (action.type) {
    case actionTypes.SHOW_PROPERTY_COUNT:
      return {
        ...state,
        propertyCount: action.data
      };
    case actionTypes.SEARCH_PROPERTY_LOCATION:
      return {
        ...state,
        propertyLocation: action.data
      };
    case actionTypes.SEARCH_FILTER_SORT_BY:
      return {
        ...state,
        sortBy: action.data
      };
    case actionTypes.SEARCH_PROPERTY_DATERANGE:
      return {
        ...state,
        propertyDaterange: action.data
      };
    case actionTypes.SEARCH_FILLTER_PRICE:
      return {
        ...state,
        price: action.data
      };
    case actionTypes.SEARCH_FILTER_VIEW:
      return {
        ...state,
        view: action.data
      };
    case actionTypes.SEARCH_FILLTER_AMENITIES:
      return {
        ...state,
        amenitiesData: action.data
      };
    case actionTypes.SEARCH_PROPERTY_GUEST:
      switch (action.data.title) {
        case 'Adults':
          adultsCount = action.data.count;
          break;
        case 'Children':
          childrenCount = action.data.count;
          break;
        case 'Babies':
          babiesCount = action.data.count;
          break;
        case 'Pets':
          petsCount = action.data.count;
          break;
        case 'Beds':
          bedCount = action.data.count;
          break;
        case 'Bathrooms':
          bathroomCount = action.data.count;
          break;
        case 'Bedrooms':
          bedroomCount = action.data.count;
          break;
        default:
          break;
      }

      return {
        ...state,
        childrenCount: childrenCount,
        adultsCount: adultsCount,
        babiesCount: babiesCount,
        petsCount: petsCount,
        bedCount: bedCount,
        bathroomCount: bathroomCount,
        bedroomCount: bedroomCount,
        totalGuest: childrenCount + adultsCount
      };
    case actionTypes.SEARCH_PROPERTY_TRAVELING:
      switch (action.data.forId) {
        case 'work':
          travelingWork = action.data.status;
          break;
        case 'children':
          travelingChild = action.data.status;
          break;
        default:
          break;
      }
      return {
        ...state,
        travelingWork: travelingWork,
        travelingChild: travelingChild
      };
    case actionTypes.SEARCH_PAGINATION_LIMIT:
      return {
        ...state,
        paginationLimit: action.data
      };
    case actionTypes.SEARCH_PAGINATION_OFFSET:
      return {
        ...state,
        paginationOffset: action.data
      };
    default:
      return state;
  }
};
export default result;
